import {deToNumberString} from "./transformations"

const regexFloatingNumberChars = /^[0-9,.-]*$/
const regexIntegerChars = /^[0-9.-]*$/
const regexNumberChars = /^[0-9]*$/
const regexNumberAndAlphabetChars = /^[a-zA-Z0-9]*$/
const regexInteger = /^((-)?([0-9]{1,3}([0-9]*|(\.[0-9]{3})*)))?$/
const regexCurrency = /^((-)?([0-9]*([0-9]*([,][0-9]*)?|(\.[0-9]*)*(,[0-9]*)?)))?$/
const regexContact = /^.{0,150}$/
const regexPhoneNumber = /^[0-9\s]*$/
const regexHausnummer = /^[a-z0-9-]*$/
const regexPLZonChange = /^[0-9]{0,5}$/
const regexPLZonBlur = /^[0-9]{5}$/
const regexEMail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const regexHSN = /^[0-9]{4}$/
const regexTSN = /^[0-9]{3}$|^[a-zA-Z]{3}$/
const regexKennzeichen = /^[a-zA-Z0-9 \-()]{0,18}$/
const regexFahrzeugIdOnChange = /^[a-zA-Z0-9]{0,17}$/
const regexFahrzeugId = /^[a-zA-Z0-9]{17}$/
const regexFahrleistungJahr = /[0-9]{1,2}/
const regexHSNWithLength = /^[0-9]{0,4}$/
const regexTSNWithLength = /^[a-zA-Z0-9]{0,3}$/

const curreyedValidation = (regex, message) => (value) => regex.test(value) ? "" : message

export const validateInteger = curreyedValidation(regexInteger, "Keine ganze Zahl!")
export const validateIntegerChars = curreyedValidation(regexIntegerChars, "Nur Ziffern und Punkte sind erlaubt!")
export const validateFloatingChars = curreyedValidation(regexFloatingNumberChars, "Nur Ziffern, Punkte und Kommas sind erlaubt!")
export const validateNumberChars = curreyedValidation(regexNumberChars, "Nur Ziffern sind erlaubt!")
export const validateNumberAndAlphabetChars = curreyedValidation(regexNumberAndAlphabetChars, "Nur Ziffern und Buchstaben sind erlaubt!")
export const validateCurrency = curreyedValidation(regexCurrency, "Keine gültige Zahl!")
export const validateContactChars = curreyedValidation(regexContact, "Maximal 150 Zeichen erlaubt.")
export const validatePhoneNumber = curreyedValidation(regexPhoneNumber, "Nur Ziffern und Leerzeichen sind erlaubt.")
export const validateHausnummer = curreyedValidation(regexHausnummer, "Nur Ziffern, Buchstaben und - erlaubt.")
export const validatePLZOnChange = curreyedValidation(regexPLZonChange, "Nur Ziffern erlaubt.")
export const validatePLZonBlur = curreyedValidation(regexPLZonBlur, "PLZ muss genau 5 Zeichen besitzen.")
export const validateEmail = curreyedValidation(regexEMail, "Bitte geben Sie eine gültige E-Mail-Adresse ein.")
export const validateHSNOnBlur = curreyedValidation(regexHSN, "Die Herstellernummer (HSN) muss 4-stellig sein. Bitte korrigieren Sie Ihre Eingabe.")
export const validateTSNOnBlur = curreyedValidation(regexTSN, "Die Typschlüsselnummer (TSN) muss 3-stellig sein. Bitte korrigieren Sie Ihre Eingabe.")
export const validateKennzeichen = curreyedValidation(regexKennzeichen, "Maximal 18 Stellen, Ziffern, Buchstaben, Bindestrich, Leerzeichen und Klammern" +
    " sind zulässig.")
export const validateFahrzeugIdOnChange = curreyedValidation(regexFahrzeugIdOnChange, "Die Fahrzeugidentifikationsnummer muss 17-stellig sein. Bitte korrigieren Sie" +
    " Ihre Eingabe")
export const validateFahrzeugIdOnBlur = curreyedValidation(regexFahrzeugId, "Die Fahrzeugidentifikationsnummer muss 17-stellig sein. Bitte korrigieren Sie" +
    " Ihre Eingabe.")
export const validateFahrleistungJahrOnBlur = curreyedValidation(regexFahrleistungJahr, "Bitte erfassen Sie die jährliche Fahrleistung.")

export const validateHSNWithLength = curreyedValidation(regexHSNWithLength, "Die Herstellernummer (HSN) muss 4-stellig sein und darf nur Zahlen enthalten.")

export const validateTSNWithLength = curreyedValidation(regexTSNWithLength, "Die Typschlüsselnummer (TSN) muss 3-stellig sein und darf nur Buchstaben und" +
    " Zahlen enthalten.")

export function getMaxValidation(max) {
    return (value) => Number(deToNumberString(value)) > max && `Der Wert darf nicht größer als ${max} sein.`
}

export function getMinValidation(min) {
    return (value) => Number(deToNumberString(value)) < min && `Der Wert darf nicht kleiner als ${min} sein.`
}

export function isValidRnfFahrleistung(values) {
    return values.floatValue < 100
        && values.floatValue > 0
        || values.value === ""
}

export function isValidGroesseOrGewicht(values) {
    return values.floatValue < 999
        && values.floatValue > 0
        || values.value === ""
}